import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class ProfileElementGroupComponent extends Component {
  static readonly TYPE_ID: string = '3505e71590074448aece1d83d7498639';

  constructor(
    public readonly groupId: string,
  ) {
    super();
  }

  get $removable(): boolean {
    return false;
  }

  get $typeId(): string {
    return ProfileElementGroupComponent.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): ProfileElementGroupComponent {
    return new ProfileElementGroupComponent(
        MapUtils.get<string>(map, 'groupId'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'groupId': this.groupId,
    };
  }

  clone(): this {
    return new ProfileElementGroupComponent(
        this.groupId,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.groupId === this.groupId;
  }
}

export class ProfileElementGroupComponentBuilder extends DataModelBuilder<ProfileElementGroupComponent> {
  build(context: SerializationContext, map: SerializedData): ProfileElementGroupComponent {
    return ProfileElementGroupComponent.fromMap(context, map);
  }
}
